export default __webpack_public_path__ + "static/media/icon_download.d5162a91.svg";